import { Observable } from "rxjs/Observable";
import * as actions from "./contact-type.actions";
import { ContactType } from "./contact-type.model";
import { ContactTypeFilters } from "./contact-type.reducer";
import { CategoryStoreFacade } from "../category/category.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class ContactTypeStoreFacade extends CategoryStoreFacade<ContactType> {

    getAll(): Observable<Array<ContactType>> {
        return this.select(Qry.getInstance().contactType.byActiveAccount);
    }

    getForAllAccounts(): Observable<Array<ContactType>> {
        return this._getForAllAccounts("contactType", "contactTypes");
    }

    getFiltered(): Observable<Array<ContactType>> {
        return this.select(Qry.getInstance().contactType.filtered);
    }

    create(contactType: ContactType): void {
        this.dispatch(new actions.SubmitAction(contactType));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachContactType(membership, contactType, {restful: false, persistable: true});
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    insert(contactType: ContactType): void {
        this.dispatch(new actions.SubmitAction(contactType, {persistable: true, restful: false}));
    }

    remove(contactType: ContactType, options?: ActionOptionsArgs): void {
        this.checkCanDelete(contactType);
        this.appFacade.objects.contact.store.removeByContactType(contactType, options);

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachContactType(membership, contactType, {restful: false, persistable: true});
        });

        this.dispatch(new actions.RemoveAction(contactType, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    update(contactType: ContactType): void {
        this.dispatch(new actions.SubmitAction(contactType));
    }

    setFilters(filters: ContactTypeFilters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    canDelete(contactType: ContactType): Observable<boolean> {
        return this.checkHasDependency(this.appFacade.objects.contact.store, contactType, "Contacts")
            .switchMap(() => super.canDelete(contactType));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact-type/contact-type.store-facade.ts